import CheckboxGroup from "@/components/CheckboxGroup";

import { useFilterContext } from "../FilterContext";

const FilterItemBanks = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();
  return (
    <CheckboxGroup
      options={filterOptions.benefitsOptions}
      value={filterData.benefits}
      onChange={(value) => {
        setFilterData({
          benefits: value,
        });
      }}
    />
  );
};

export default FilterItemBanks;
